module.exports = __webpack_public_path__ + "img/inventory-quant-logo.806ec52c.png";